import {newCOLORS} from 'core/styles';
import styled from 'styled-components';

const TabLinkStyles = styled.div`
    font-weight: ${(props) => (props?.isActive ? 'bold' : 'normal')};
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    display: inline-block;
    margin-right: 24px;
    cursor: pointer;
    color: ${(props) => (props?.isActive ? newCOLORS.primary300 : newCOLORS.gray400)};
    border-bottom: ${(props) =>
        props?.isActive ? `4px solid ${newCOLORS.primary300}` : 'none'};

    &:hover {
        border-bottom: ${(props) =>
            props?.isActive
                ? `4px solid ${newCOLORS.primary300}`
                : `4px solid ${newCOLORS.gray300}`};
    }
`;
export default TabLinkStyles;
